import { useCallback, useMemo } from 'react';

// derives display props and stable handlers from a lifecare section comment.
// kept context-free so the lifecare studio doesn't have to host the full
// demand studio context just to render one card.
const useLifecareStudioComment = ({
  section,
  uiState,
  updateSectionComment,
  handleRegenerateSection,
}) => {
  const sectionId = section?.id || '';
  const label = section?.label || 'Lifecare Plan';
  const name = `lifecareStudioComment-${sectionId || 'empty'}`;
  const value = section?.comment || '';

  const onChange = useCallback(
    (nextValue) => {
      if (!sectionId) return;
      updateSectionComment(sectionId, nextValue);
    },
    [sectionId, updateSectionComment]
  );

  const onRegenerate = useCallback(() => {
    if (!sectionId) return;
    console.log("Life care studio comment calls regenerate for section ", sectionId);
    handleRegenerateSection(sectionId);
  }, [sectionId, handleRegenerateSection]);

  return useMemo(
    () => ({
      label,
      name,
      value,
      uiState,
      onChange,
      onRegenerate,
    }),
    [label, name, value, uiState, onChange, onRegenerate]
  );
};

export default useLifecareStudioComment;
